import { put, takeLatest, all } from 'redux-saga/effects'

import {
  FETCH_ALL_F2F_PERFORMERS_START,
  FACE_2_FACE_SEND_TIP
} from '../actions/ActionConstant'
import {
  fetchAllF2FPerformersSuccess,
  fetchAllF2FPerformersFailure,
} from '../actions/F2FAction'
import {
  getErrorNotificationMessage, getSuccessNotificationMessage
} from '../../components/helper/NotificationMessage'
import { createNotification } from 'react-redux-notify'
import F2FServices from '../../helpers/services/f2f/user'
import { parseStreamingServiceError } from '../../helpers/services/streaming/error'
import { f2fSendTipFailure, f2fSendTipSuccess } from '../actions/Face2FaceAction'
import { showErrorComponent } from '../actions/ComponentAction'
import ErrorUtils from "../../helpers/utils/errors"
import SendTipService from "../../helpers/services/payment/f2fTip"



function* fetchAllF2FPerformersAPI(action) {
  try {
    const response = yield F2FServices.getAllPerformers(action.data)
    yield put(fetchAllF2FPerformersSuccess({
      performers: response.data?.result || [],
      pagination: response?.data?.metadata?.pagination || {}
    }))
  } catch (error) {
    const message = parseStreamingServiceError(error.response.data)
    yield put(fetchAllF2FPerformersFailure(message))
    const notificationMessage = getErrorNotificationMessage(message)
    yield put(createNotification(notificationMessage))
  }
}

function* sendTipToPerformerFromWallet(action) {
  try {
    const { onSuccess, ...other } = action.data;
    const response = yield SendTipService.sendTipToPerformer(other);
    if (response && response.data.success) {
      yield put(f2fSendTipSuccess(response?.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      onSuccess(response.data);
    } else {
      yield put(f2fSendTipFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(f2fSendTipFailure(error));
    if (error?.response?.status !== 400) {
      yield put(showErrorComponent({ error: error, status: error?.response?.status ? error?.response?.status : 500 }));
    }
    const { notify, message } = ErrorUtils.handleApiException(error)
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

export default function* pageSaga() {
  yield all([
    yield takeLatest(FETCH_ALL_F2F_PERFORMERS_START, fetchAllF2FPerformersAPI)
  ]);
  yield all([
    yield takeLatest(FACE_2_FACE_SEND_TIP, sendTipToPerformerFromWallet)
  ]);
}
